import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'deliveryLog';

// Action Types
export const types = {
  GET_DELIVERY_LOG: createAsyncTypes(`${KEY}/GET_DELIVERY_LOG`),
  RESET_DELIVERY_LOG: `${KEY}/RESET_DELIVERY_LOG`,
  RESET_EXPORT_DATA: `${KEY}/RESET_EXPORT_DATA`
};

export interface Transaction {
  id: string;
  orderNumber: string;
  orderTime: string;
  kioskName: string;
  flow: string;
  deliveryType: string;
  ticketsSold: number;
  failedTicketCount: number;
}

export interface DeliveryLogState {
  readonly data: Transaction[];
  readonly hasMore: boolean;
  readonly pending: boolean;
  readonly error: string | null;
  readonly totalRecords: number;
  readonly export: {
    readonly data: Transaction[];
    readonly pending: boolean;
  };
}

export interface GetDeliveryLogRequest {
  type: typeof types.GET_DELIVERY_LOG.REQUEST;
  payload: {
    page: number;
    sort: string;
    sortColumn: string;
    orderNumber: string;
    startTime: Date;
    endTime: Date;
    kioskIds: string[];
    flows: string[];
    deliveryTypes: string[];
    exportData?: boolean;
  };
}

export interface GetDeliveryLogError {
  type: typeof types.GET_DELIVERY_LOG.ERROR;
  payload: string;
}

export interface GetDeliveryLogPending {
  type: typeof types.GET_DELIVERY_LOG.PENDING;
  payload: { pending: boolean; exportData: boolean };
}

export interface GetDeliveryLogSuccess {
  type: typeof types.GET_DELIVERY_LOG.SUCCESS;
  payload: {
    data: Transaction[];
    total: number;
    exportData: boolean;
  };
}

export interface GetDeliveryLogResponse {
  data: Transaction[];
  total: number;
}

export interface ResetDeliveryLog {
  type: typeof types.RESET_DELIVERY_LOG;
}

export interface ResetExportData {
  type: typeof types.RESET_EXPORT_DATA;
}

export type DeliveryLogActionTypes =
  | GetDeliveryLogRequest
  | GetDeliveryLogSuccess
  | GetDeliveryLogError
  | GetDeliveryLogPending
  | ResetDeliveryLog
  | ResetExportData;
